import React, { Component } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import PropTypes from "prop-types";
import {
  actionAppliedCandidateList,
  allCandidatesList,
} from "../Actions/CandidateAction";
import {
  changeStatus,
  getUniversityList,
  getInstituteList,
} from "../Actions/AdminAction";
import { token, roleid } from "../Actions/AuthAction";
import ReactPaginate from "react-paginate";
import { showLoader, hideLoader } from "../../utils";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import Loader from "../Common/Loader";
import CONFIG from "../../config";
import {
  GetSkill,
  selectFilterCities,
  selectState,
} from "../Actions/CommonAction";

export default class AdminAllCandidateList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: token(),
      data: [],
      totalCount: 0,
      showModel: false,
      limit: 9,
      currentPage: 0,
      search: "",
      status: 0,
      istrending: "",
      sampleImage: "assets/img/profile.png",
      state: "",
      city: "",
      skill: [],
      instid: "",
      uniid: "",
      loading: true,
      UniversityList: [],
      InstituteList: [],
      StateList: [],
      SkillList: [],
    };
  }

  componentDidMount() {
    const {
      search,
      status,
      state,
      city,
      skill,
      instid,
      uniid,
      currentPage,
      token,
      limit,
    } = this.state;
    const model = {
      key: token,
      page: currentPage + 1,
      search: search,
      status: status,
      state: state,
      city: city,
      skill: skill,
      instid: instid,
      uniid: uniid,
      limit: limit,
    };

    this.setState({
      currentPage: 0,
    });

    getUniversityList({
      page: -1,
      search: "",
      status: "",
      city: "",
      state: "",
      limit: 1000,
      key: token,
    }).then((res) => {
      console.log("u", res.data);
      this.setState({
        UniversityList: res.data,
      });
      // setOptions(this, this.state.unniversityList.name, res.data);
    });
    this.loadList(model);

    getInstituteList({
      page: -1,
      search: "",
      status: "",
      city: "",
      state: "",
      limit: 1000,
      key: token,
    }).then((res) => {
      console.log("u", res.data);
      this.setState({
        InstituteList: res.data,
      });
      // setOptions(this, this.state.unniversityList.name, res.data);
    });
    this.loadList(model);

    selectState({
      page: -1,
      search: "",
      status: "",
      city: "",
      state: "",
      limit: 1000,
      key: token,
    }).then((res) => {
      console.log("u", res.data);
      this.setState({
        StateList: res.data,
      });
      // setOptions(this, this.state.unniversityList.name, res.data);
    });
    this.loadList(model);

    GetSkill({
      status: 1,
      search: "",
      limit: 1000,
      key: token,
    }).then((res) => {
      console.log("u", res.data);
      this.setState({
        SkillList: res.data,
      });
    })
  }

  loadList = (model) => {
    this.setState({
      loading: true,
    });
    allCandidatesList(model)
      .then((res) => {
        hideLoader(this);
        this.setState({
          totaldata: res.totaldata,
          data: res.data,
          originalData: res.data,
          totalCount: res.totaldata,
          loading: false,
        });
      })
      .catch((e) => hideLoader(this));
  };

  OnCheckboxStatusChange = (e, code) => {
    Swal.fire({
      title: `Are you sure, you want to mark this candidate as ${e.target.checked ? "InActive" : "Active"
        } ?`,
      text: "",
      icon: "",
      buttons: true,
      dangerMode: false,
    }).then((willDelete) => {
      if (willDelete) {
        const { data } = this.state;
        data.map((item) => {
          if (item.user.id === code) {
            item.user.status = e.target.checked;
          }
        });

        console.log(e.target.checked);
        console.log(code);
        this.setState({ data }, () => {
          changeStatus({
            loginusertoken: token(),
            userid: code,
            status: !e.target.checked,
          }).then((res) => {
            console.log("status updated");
            Swal.fire("Success", res.message, "success");
          });
        });
      }
    });
  };

  handlePageClick = (data) => {
    let selected = data.selected;

    this.setState(
      {
        currentPage: selected,
      },
      () => {
        const {
          search,
          status,
          city,
          state,
          limit,
          token,
          skill,
          instid,
          uniid,
        } = this.state;
        const model = {
          key: token,
          page: selected + 1,
          search: search,
          status: status,
          state: state,
          city: city,
          skill: skill,
          instid: instid,
          uniid: uniid,
          limit: limit,
        };
        this.loadList(model);
      }
    );
  };

  filterdata = (data) => {
    const {
      search,
      status,
      city,
      state,
      limit,
      token,
      skill,
      instid,
      uniid,
      currentPage,
    } = this.state;
    const model = {
      key: token,
      page: currentPage + 1,
      search: search,
      status: data,
      state: state,
      city: city,
      skill: skill,
      instid: instid,
      uniid: uniid,
      limit: limit,
    };
    this.loadList(model);
  };



  searchdata = (data) => {
    const {
      search,
      status,
      city,
      state,
      limit,
      token,
      skill,
      instid,
      uniid,
      currentPage,
    } = this.state;
    const model = {
      key: token,
      page: currentPage + 1,
      search: data,
      status: status,
      state: state,
      city: city,
      skill: skill,
      instid: instid,
      uniid: uniid,
      limit: limit,
    };
    this.loadList(model);
  };

  onSearchValue = (e) => {
    this.setState({
      search: e.target.value,
    });
  };

  onUniversiytChange = (e) => {
    this.setState(
      {
        uniid: e.target.value,
      },
      () => {
        if (e.target.name === "unicode") {
          const {
            search,
            status,
            city,
            state,
            limit,
            token,
            skill,
            instid,
            uniid,
            currentPage,
          } = this.state;
          const model = {
            key: token,
            page: currentPage + 1,
            search: search,
            status: status,
            state: state,
            city: city,
            skill: skill,
            instid: instid,
            uniid: e.target.value,
            limit: limit,
          };
          this.loadList(model);
          //this.setState({currentPage : 0})
        }
      }
    );
  };

  onInstituteChange = (e) => {
    this.setState(
      {
        instid: e.target.value,
      },
      () => {
        if (e.target.name === "inscode") {
          const {
            search,
            status,
            city,
            state,
            limit,
            token,
            skill,
            instid,
            uniid,
            currentPage,
          } = this.state;
          const model = {
            key: token,
            page: currentPage + 1,
            search: search,
            status: status,
            state: state,
            city: city,
            skill: skill,
            instid: e.target.value,
            uniid: uniid,
            limit: limit,
          };
          this.loadList(model);
          //this.setState({currentPage : 0})
        }
      }
    );
  };

  onStateChange = (e) => {
    this.setState(
      {
        state: e.target.value,
      },
      () => {
        if (e.target.name === "statecode") {
          const {
            search,
            status,
            city,
            state,
            limit,
            token,
            skill,
            instid,
            uniid,
            currentPage,
          } = this.state;
          const model = {
            key: token,
            page: currentPage + 1,
            search: search,
            status: status,
            state: e.target.value,
            city: city,
            skill: skill,
            instid: instid,
            uniid: uniid,
            limit: limit,
          };
          this.loadList(model);
          //this.setState({currentPage : 0})
        }
      }
    );
  };


  onSkillSelect = (e) => {
    this.setState(
      {
        skillcode: e.target.value,
      },
      () => {
        if (e.target.name === "skillname") {
          const {
            search,
            status,
            city,
            state,
            limit,
            token,
            skill,
            instid,
            uniid,
            currentPage,
          } = this.state;
          const model = {
            key: token,
            page: currentPage + 1,
            search: search,
            status: status,
            state: state,
            city: city,
            skill: e.target.value,
            instid: instid,
            uniid: uniid,
            limit: limit,
          };
          this.loadList(model);
          //this.setState({currentPage : 0})
        }
      }
    );
  };

  render() {
    const {
      data,
      totalCount,
      limit,
      sampleImage,
      loading,
      UniversityList,
      InstituteList,
      StateList,
      SkillList,
    } = this.state;
    return (
      <>
        {loading && <Loader />}
        <div className="row mb-4">
          <div className="col-md-12">
            <h4 className="table_heading position-relative">CANDIDATES LIST</h4>
          </div>
        </div>
        <div class="d-flex justify-content-between">
          <h6 className="text-black font-weight-bold">
            <span>{`${this.state.currentPage
              ? this.state.currentPage * this.state.limit + 1
              : 1
              }-${data.length < limit
                ? totalCount
                : (this.state.currentPage + 1) * this.state.limit
              }`}</span>{" "}
            <span>{this.state.totalCount} Search Results</span>
          </h6>
        </div>
        <div className="row">
          <div className="col-md-3 order-sm-12">
            <div className="card formcard p-2 mb-3">
              <p className="text-black font-weight-bold table_heading position-relative">
                Filter
              </p>
              <form className="form-group">
                <div className="form-group col-md-12 position-relative">
                  <input
                    className="form-control rounded-pill"
                    type="text"
                    placeholder="Search"
                    value={this.state.search}
                    onChange={this.onSearchValue}
                  />
                  <button
                    type="button"
                    className="search-btn filterbtn"
                    onClick={(e) => this.searchdata(this.state.search)}
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>
                <div className="form-group col-md-12">
                  <label className="mb-1" for="inputEmailAddress">
                    Status
                  </label>
                  <select
                    onChange={(e) => this.filterdata(e.target.value)}
                    className="form-control"
                  >
                    <option value="">All</option>
                    <option value="1">Active</option>
                    <option value="0">InActive</option>
                  </select>
                </div>

                {roleid() == 6 ? (
                  <></>
                ) : (
                  <div className="form-group col-md-12">
                    <label className="mb-1" for="inputEmailAddress">
                      University
                    </label>
                    <select
                      class="form-control"
                      onChange={this.onUniversiytChange}
                      name="unicode"
                    >
                      <option value="">Select University</option>
                      {UniversityList.map((item) => (
                        <option value={item.id}>{item.university_name}</option>
                      ))}
                    </select>
                  </div>
                )}

                {roleid() == 2 ? (
                  <></>
                ) : (
                  <div className="form-group col-md-12">
                    <label className="mb-1" for="inputEmailAddress">
                      Institute
                    </label>
                    <select
                      class="form-control"
                      onChange={this.onInstituteChange}
                      name="inscode"
                    >
                      <option value="">Select Institutions</option>
                      {InstituteList.map((item) => (
                        <option value={item.id}>{item.name}</option>
                      ))}
                    </select>
                  </div>
                )}

                <div className="form-group col-md-12">
                  <label className="mb-1" for="inputEmailAddress">
                    State
                  </label>
                  <select
                    class="form-control"
                    onChange={this.onStateChange}
                    name="statecode"
                  >
                    <option value="">Select State</option>
                    {StateList.map((item) => (
                      <option value={item.state_id}>{item.name}</option>
                    ))}
                  </select>
                </div>

                <div className="form-group col-md-12">
                  <label className="mb-1" for="inputEmailAddress">
                    Skill
                  </label>
                  <select
                    className="form-control"
                    onChange={this.onSkillSelect}
                    name="skillname"
                  >
                    <option value="">Select Skill</option>
                    {SkillList.map((item) => (
                      <option value={item.skillcode}>{item.skillname}</option>
                    ))}
                  </select>
                </div>
              </form>
            </div>
          </div>
          <div className="col-md-9 order-sm-1">
            <div className="row">
              {this.state.data
                ? this.state.data.map((item, i) => (
                  <div className="col-md-4">
                    <div className="card mb-3" style={{ minHeight: "455px" }}>
                      <div className="card-body">
                        <div className="d-flex justify-content-between mb-4">
                          <p className="mb-0 text-muted">
                            <strong>Roll No: {item.rollnumber}</strong>
                          </p>
                          <span className="tabledropdown">
                            <span className="abtn">
                              <i
                                class="fa fa-ellipsis-v"
                                id="dropdownMenuLink"
                                data-toggle="dropdown"
                              ></i>
                              <div
                                class="dropdown-menu editdrp"
                                aria-labelledby="dropdownMenuLink"
                              >
                                {item.address ? (
                                  <Link
                                    class="dropdown-item"
                                    to={`/profile/${item.id}`}
                                  >
                                    View Profile
                                  </Link>
                                ) : (
                                  <p
                                    className="m-2 cursor-pointer"
                                    onClick={() =>
                                      Swal.fire(
                                        "Candidate has not competed his Profile"
                                      )
                                    }
                                  >
                                    {" "}
                                    View Profile
                                  </p>
                                )}
                              </div>
                            </span>
                          </span>
                        </div>
                        <div className="text-center">
                          {item.profilepic && item.profilepic ? (
                            <img
                              src={`${CONFIG.IMAGE_URL}/${item.profilepic}`}
                              alt="Image not available"
                              className="listprofilepic shadow"
                            />
                          ) : (
                            <img
                              src={sampleImage}
                              alt="Image not available"
                              className="listprofilepic shadow"
                            />
                          )}

                          <p className="mb-0">
                            <strong>
                              {item.firstname} {item.lastname}
                            </strong>
                          </p>
                          <p className="mb-0">
                            <strong>
                              {item.gender == 1 ? "Male" : "Female"}
                            </strong>
                          </p>
                          <p className="mb-0">{item.user.phone}</p>
                          <p>{item.user.email}</p>
                          <p className="mb-0">
                            <strong>Institute Name</strong>
                          </p>
                          <p>{item.inst.name}</p>
                          <p className="mb-0">
                            <strong>University Name</strong>
                          </p>
                          <p>{item.uni.university_name}</p>
                        </div>
                        <div
                          class="position-absolute"
                          style={{ bottom: "0", right: "10px" }}
                        >
                          <p>
                            <label className="switch switchyes">
                              <input
                                type="checkbox"
                                checked={item.user.status ? 0 : 1}
                                onChange={(e) =>
                                  this.OnCheckboxStatusChange(e, item.user.id)
                                }
                              />
                              <span className="slidernormal round"></span>
                            </label>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
                : null}
            </div>
            <div className="d-flex justify-content-center">
              <div class="pagination">
                <ReactPaginate
                  previousLabel={
                    <i
                      className="fa fa-angle-double-left"
                      aria-hidden="true"
                    ></i>
                  }
                  nextLabel={
                    <i
                      className="fa fa-angle-double-right"
                      aria-hidden="true"
                    ></i>
                  }
                  pageCount={
                    this.state.totalCount % this.state.limit === 0
                      ? parseInt(this.state.totalCount / this.state.limit)
                      : parseInt(this.state.totalCount / this.state.limit) + 1
                  }
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageClick}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}